import { render } from "./NativeAds.vue?vue&type=template&id=48b950e0"
import script from "./NativeAds.vue?vue&type=script&lang=js"
export * from "./NativeAds.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__